import chroma from "chroma-js";

export function interpolateColor(colorA: string, colorB: string, t: number) {
  return chroma(colorA).mix(chroma(colorB), t).hex();
}

export function hexColorWithOpacity(color: string, opacity: number) {
  return chroma(color).alpha(opacity).hex();
}

/** Match CSS color-mix(in srgb, ...) and keep small labels readable across the full ramp. */
export function contrastTextOnBlend(surface: string, tone: string, intensity: number): string {
  const background = chroma.mix(surface, tone, Math.max(0, Math.min(100, intensity)) / 100, "rgb");
  return chroma.contrast(background, "#FFFFFF") >= 4.5 ? "#FFFFFF" : "#000000";
}
